import SpecialtyScreen from './SpecialtyScreen.js';

export default SpecialtyScreen;
